import { PublicClientApplication, LogLevel } from "@azure/msal-browser";
import '@fortawesome/fontawesome-free/css/all.min.css';
import './style.css'; 
import genailogo from '../public/images/genailogo.png';
import dailogosolohtml from '../public/images/dailogosolohtml.png';
import { CopilotStudioClient } from "@microsoft/agents-copilotstudio-client";
import { BlobServiceClient } from '@azure/storage-blob';

const chatForm = document.getElementById('chat-form');
const chatInput = document.getElementById('chat-input');
const signinBtn = document.getElementById('signin-btn');
const chatMessages = document.getElementById('chat-messages');
const chatBubble = document.getElementById('chat-bubble-container');
const signinOverlay = document.getElementById("signin-overlay");
const chatContainer = document.getElementById('chatbot-container');
const chatNotification = document.getElementById('chat-notification');
const typingIndicatorBubble = document.getElementById('typing-indicator-bubble');

let botStartMessage = 'Hello! I am your Copilot chat agent. How can I help you today?';
let isMinimized = false;
let replyFormatted;
let conversationId;
let copilotClient;
let startAct;
let filename;
let history;
let messages;

const settings = {
  environmentId: process.env.ENVIRONMENT_ID,
  agentIdentifier: process.env.AGENT_IDENTIFIER,
  tenantId: process.env.TENANT_ID,
  appClientId: process.env.APP_CLIENT_ID
};

const blobSettings = {
  sasUrl: process.env.BLOB_SAS_URL,
  containerName: process.env.CONTAINER_NAME,
  blobname: ''
};
const scopes = ["https://api.powerplatform.com/.default"];
console.log('Agent:', settings.agentIdentifier);

document.addEventListener('DOMContentLoaded', () => {

const msalInstance = new PublicClientApplication({
  auth: {
    clientId: settings.appClientId,
    authority: `https://login.microsoftonline.com/${settings.tenantId}`,
    redirectUri: window.location.origin + "/"
  },
  system: { loggerOptions: { logLevel: LogLevel.Warning } }
});

async function initMsal() {
  await msalInstance.initialize();

  const currentAccounts = msalInstance.getAllAccounts();

  if (currentAccounts.length > 0) {
    const account = currentAccounts[0];
    filename = account.localAccountId;
    blobSettings.blobname = filename;
      //console.log('Filename for blob storage:', filename);
    try {
      const silentResult = await msalInstance.acquireTokenSilent({
        scopes,
        account
      });
      const accessToken = silentResult.accessToken;
      copilotClient = new CopilotStudioClient(settings, accessToken);
      showToast('Signed in!');
        //console.log('Silent sign-in successful!');
      // Proceed with UI setup
      setupChatAfterSignIn(account);
    } catch (error) {
      console.warn('Silent sign-in failed:', error);
    }
  } else {
    //console.log("No account found. User needs to sign in.");
  }
}
// Sign in button event listener
signinBtn.addEventListener('click', async function() {
  await signIn();
});

async function signIn() {
  try {
    const loginResponse = await msalInstance.loginPopup({
      scopes,
      prompt: "select_account"
    });

    const accessToken = loginResponse.accessToken;
    const account = loginResponse.account;
    filename = account.localAccountId;
    blobSettings.blobname = filename;
    //console.log('Login response account:', account.username);
    copilotClient = new CopilotStudioClient(settings, accessToken);
    showToast('Sign-in successful!');
      //console.log('Sign-in successful!');
    signinBtn.disabled = true;
        document.body.offsetHeight;
    if (window.FontAwesome && window.FontAwesome.dom && window.FontAwesome.dom.i2svg) {
    window.FontAwesome.dom.i2svg();
  }
    await setupChatAfterSignIn(account);

  } catch (e) {
      console.error(e);
    alert("Sign-in failed! See console for details.");
    if (signinOverlay) signinOverlay.style.display = "flex";
  }
}

async function setupChatAfterSignIn(account) {
  startAct = await copilotClient.startConversationAsync(true);
  // conversationId ='7fabe6b3-b45e-4799-92f2-ea65a17a4c3f';
  conversationId = startAct.conversation.id;
  if (startAct.speak != null) {
    botStartMessage = startAct.speak;
  };
    //console.log('Start Act:', startAct);
    //console.log('conversationId:', conversationId);
    //console.log('speak:', startAct.speak);

  if (signinOverlay) signinOverlay.style.display = "none";
  if (chatBubble) chatBubble.classList.remove('hidden');


  // Set account info in UI
  if (account) {
    const accountName = document.getElementById('account-name');
    const email = document.getElementById('account-details');
    if (accountName) accountName.textContent = account.name || account.username || '';
    if (email) email.textContent = account.username || account.homeAccountId || '';
    const name = encodeURIComponent(accountName.textContent.trim());
    const avatarUrl = `https://ui-avatars.com/api/?name=${name}&background=ececec&color=222&size=32`;
    const accountImg = document.getElementById("account-img");
    accountImg.src = avatarUrl;
  }
  const dailogo = document.getElementById("dailogo");
  dailogo.src = dailogosolohtml;

  const genailogo_bubble = document.getElementById("chat-bubble-icon");
  genailogo_bubble.src = genailogo;

  const genailogo_login = document.getElementById("genailogo");
  genailogo_login.src = genailogo;

  setupSuggestionButtons();
  summarizeRecentUserMessages('last3');
  chatInput.focus();

  const reloadFontAwesome = () => {
  const existing = document.querySelector('link[href*="font-awesome"]');
  if (existing) existing.remove();

  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css';
  document.head.appendChild(link);
};
}
initMsal();
async function appendToBlob(conversationId, sender, messageText) {
  try {
    const blobServiceClient = new BlobServiceClient(blobSettings.sasUrl);
    const containerClient = blobServiceClient.getContainerClient(blobSettings.containerName);
    //console.log('Container client obtained.');
    const blobName = `${blobSettings.blobname}.json`;
      // //console.log('Appending to blob:', blobName);
    const appendBlobClient = containerClient.getAppendBlobClient(blobName);
    //console.log('AppendBlobClient created.');
    const exists = await appendBlobClient.exists();
    //console.log('Blob exists:', exists);
    if (!exists) {
      await appendBlobClient.create(); // Creates an Append Blob
    } else {
      const properties = await appendBlobClient.getProperties();
      if (properties.blobType !== 'AppendBlob') {
        throw new Error(`Blob exists but is type ${properties.blobType}. Cannot append.`);
      }
    }


    const entry = {
      activity: {
        type: "message",
        timestamp: new Date().toISOString(),
        sender,
        text: messageText,
        conversation: { id: conversationId }
      }
    };
    //console.log('Appending entry to blob:', entry);

    const line = JSON.stringify(entry) + ',\n';
    //console.log('Line to append:', line);
    await appendBlobClient.appendBlock(line, Buffer.byteLength(line));   
    //console.log('Appended message:', entry);
  } catch (error) {
      console.error('Error appending to blob:', error.message);
  }
}

async function getPreviousMessages(conversationid,history) {
  try {
    const blobServiceClient = new BlobServiceClient(blobSettings.sasUrl);
    const containerClient = blobServiceClient.getContainerClient(blobSettings.containerName);
    const blobName = `${blobSettings.blobname}.json`;
    const blobClient = containerClient.getBlobClient(blobName);
  //console.log('Reading from blob:', blobName);
    const exists = await blobClient.exists();
if (!exists) {
  await appendBlobClient.create();
  //console.log(`Created new append blob: ${blobName}`);
}
    const response = await blobClient.download();
    //console.log('Blob download response received.',response);
    const blob = await response.blobBody;
    //console.log('Readable stream obtained from blob.', blob);
    const rawText = await blob.text();
    //console.log('Raw blob text:', rawText);
    const cleaned = `[${rawText.trim().replace(/,\s*$/, '')}]`;
      try {
      messages = JSON.parse(cleaned);
     //console.log('Total messages parsed:', messages.length);
    } catch (err) {
      console.error('Failed to parse JSON:', err.message);
    }
if (conversationid == null && history === 'last3') {
      const userMessages = messages.filter(msg => msg.activity?.sender === 'user');
      //console.log('Total user messages:', userMessages);

      // Group by conversation.id
      const grouped = {};
      for (const msg of userMessages) {
        const convId = msg.activity?.conversation?.id;
        if (!grouped[convId] || new Date(msg.activity.timestamp) > new Date(grouped[convId].activity.timestamp)) {
          grouped[convId] = msg;
        }
      }
      // Get most recent messages by id
      const uniqueMessages = Object.values(grouped);
      uniqueMessages.sort((a, b) => new Date(b.activity.timestamp) - new Date(a.activity.timestamp));
      const last3 = uniqueMessages.slice(0, 3);
      return last3;
    }

    if(history === 'all'){
      const userMessages = messages.filter(msg => msg.activity?.conversation.id ===conversationid);
      return userMessages;
    }

  } catch (error) {
    console.error('Error reading blob:', error.message);
    return [];
  }
}

async function summarizeRecentUserMessages(history) {
const last3 = await getPreviousMessages(null,history);
const conversations = document.querySelectorAll('.conversation');
const timestampDivs = document.querySelectorAll('.conversation-title');

conversations.forEach((btn, index) => {
  if (last3[index]) {
    const message = last3[index].activity;
    const date = message.timestamp ? new Date(message.timestamp) : null
    const formattedDate = date ? formatTimestamp(date) : 'No timestamp';
    timestampDivs[index].textContent = formattedDate;
    btn.textContent = message.text;
    btn.disabled = false;

    btn.addEventListener('click', function () {
      toggleChatContainer();
      chatMessages.innerHTML = '';
      conversationHistory(last3[index].activity.conversation.id,'all');
    });
  } else {
    timestampDivs[index].remove();
    btn.textContent = 'No recent message';
    btn.disabled = true;
  }

})
}

async function conversationHistory(conversationid,history){      
  const previousMessages = await getPreviousMessages(conversationid,history);
  conversationId = conversationid;  
  //console.log('Set conversationId to:', conversationId);
  previousMessages.forEach(msg => {
    if (msg.activity?.sender === 'user') {
      appendMessage(msg.activity.text, 'user', msg.activity.timestamp);
    }
    if (msg.activity?.sender === 'bot') {
      appendMessage(msg.activity.text, 'bot', msg.activity.timestamp);
    }
  });
}

// Toast notification
function showToast(message) {
  let toast = document.getElementById('toast-notification');
  if (!toast) {
    toast = document.createElement('div');
    toast.id = 'toast-notification';
    toast.className = 'toast-notification';
    document.body.appendChild(toast);
  }
  toast.textContent = message;
  toast.style.display = 'block';
  setTimeout(() => {
    toast.style.display = 'none';
  }, 3000);
}

// Chat bubble toggle
chatBubble.addEventListener('click', () => {
toggleChatContainer();
});

// Append message to chat window
function appendMessage(text, sender = 'user', datetime) {
  const messageDiv = document.createElement('div');
  messageDiv.className = `message ${sender}`;

  const bubble = document.createElement('div');
  bubble.className = `bubble ${sender}`;
  bubble.textContent = text;
  
  //timestamp
  const timestamp = document.createElement('div');
  timestamp.className = 'timestamp';
  timestamp.textContent = formatTimestamp(datetime);
  //console.log('Formatted timestamp:', timestamp.textContent);

  messageDiv.appendChild(bubble);
  messageDiv.appendChild(timestamp);
  chatMessages.appendChild(messageDiv);
  chatMessages.scrollTop = chatMessages.scrollHeight;
}

function formatTimestamp(date) {
  date = (typeof date === 'string') ? new Date(date) : date;
  return date.toLocaleString("en-US", {
    month: "short",    
    day: "numeric",    
    year: "numeric",   
    hour: "numeric",   
    minute: "2-digit", 
    hour12: true       
  });
}
//Format message to add newlines 
function formatBotMessage(input) {
if (typeof input !== 'string') {
    console.error('Invalid input: expected a string');
    return null;
  }
  let output = input;
  if (output.includes('☑')) {
    output = output.replace(/☑/g, '✅');
  }
  if (output.includes('\\n\\n')) {
    output = output.replace(/\\n\\n/g, '\n    ');
  }
  return output;
}

// Close button
document.querySelector('.chat-btn.close').addEventListener('click', () => {
  chatContainer.classList.add('hidden');
  chatMessages.innerHTML = '';
  setTimeout(() => appendMessage(botStartMessage, 'bot',new Date()), 300);
  removeTypingIndicator();
  showToast('Chat closed. Click the chat icon to start again.');
});

//Minimize button
document.querySelector('.chat-btn.minimize').addEventListener('click', () => {
  chatContainer.classList.add('minimized');
  //console.log('Minimized?', true)
  isMinimized = true;
  if (isMinimized) {
    typingIndicatorBubble.classList.remove('hidden');
  }
});

//Submit chat form
chatForm.addEventListener('submit', async function(e) {
  e.preventDefault();
  await sendMessage();
});

//Toggle Chat Container
function toggleChatContainer (){
  chatContainer.classList.remove('hidden'); // Show chat
  chatContainer.classList.remove('minimized'); // Expand chat
  isMinimized = false;
  chatNotification.classList.add('hidden');
  typingIndicatorBubble.classList.add('hidden');
  //console.log('Chat enabled!');
}

// Send user message
async function sendMessage(e) {
  if (!conversationId) return;
  const userText = chatInput.value.trim();
  if (!userText) return;
  appendMessage(userText, 'user',new Date());
  chatInput.value = '';
  await botReply(userText);
}
//Process Agent Reply
async function botReply(userText) {
  showTypingIndicator();
  if (chatContainer.classList.contains('minimized')) {
    if (typingIndicatorBubble) {
      typingIndicatorBubble.classList.remove('hidden');
      }
  }
  // Special case: if start over
  if (userText.toLowerCase() === 'start over') {
    chatMessages.innerHTML = '';
    setTimeout(() => appendMessage(startAct.speak, 'bot',new Date()), 300);
    removeTypingIndicator();
    return;
  }
  // Await bot response
  const replies = await copilotClient.askQuestionAsync(userText, conversationId);
  await appendToBlob(conversationId, 'user', userText);
  removeTypingIndicator();

  if (typingIndicatorBubble) {
    typingIndicatorBubble.classList.add('hidden');
    //console.log('Typing indicator bubble hidden');
  }
  // Process replies
 if (Array.isArray(replies)) {
    replies.forEach(({ text: t }) => {
      if (t) {
        replyFormatted = formatBotMessage(t);
        appendMessage(replyFormatted, 'bot', new Date());
        //console.log('Bot Reply:', replies);
        appendToBlob(conversationId, 'bot', replyFormatted);
      }
    });
  }

  else {
    appendMessage('Sorry, I did not understand that.', 'bot', new Date());
    //console.log('Unexpected bot reply format:', replies);
  }

  // If minimized, show notification icon
  if (chatContainer.classList.contains('minimized')) {
    chatNotification.classList.remove('hidden');
    //console.log('Chat notification shown');
  }
}

// Typing indicator helpers
function showTypingIndicator() {
  if (document.getElementById('typing-indicator')) return;
  const typingDiv = document.createElement('div');
  typingDiv.id = 'typing-indicator';
  typingDiv.className = 'message bot';
  const bubble = document.createElement('div');
  bubble.className = 'bubble bot';
  //jumping dots
  bubble.innerHTML = `
    <span class="typing-dots">
      <span class="dot"></span>
      <span class="dot"></span>
      <span class="dot"></span>
    </span>
  `;
  typingDiv.appendChild(bubble);
  chatMessages.appendChild(typingDiv);
  chatMessages.scrollTop = chatMessages.scrollHeight;
}

function removeTypingIndicator() {
  const typingDiv = document.getElementById('typing-indicator');
  if (typingDiv) typingDiv.remove();
}

function setupSuggestionButtons() {
  appendMessage(botStartMessage, 'bot',new Date());
  const suggestions = document.querySelectorAll('.suggestion');
  suggestions.forEach(button => {
    button.addEventListener('click', handleSuggestionClick);
  });

  function handleSuggestionClick(event) {
    const button = event.currentTarget;
    if (button.disabled) return;
    toggleChatContainer();
    const userText = button.textContent.trim();
    if (userText) {
      appendMessage(userText, 'user', new Date());
      botReply(userText);
    }
  }
}



});
